<div>
  <nav>
    <sk-tab-link *ngFor="let subtab of tabs"
      [lightTheme]="false"
      [name] = "subtab.name"
      [link]="buildLink(subtab)"
      [active]="isActive(subtab.route)">
    </sk-tab-link>
  </nav>
</div>